"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _fixedSession = require("../../reducers/fixedSession.js");
var _fixedSession2 = require("../../selectors/fixedSession.js");
var _findIndex2 = _interopRequireDefault(require("lodash/findIndex"));
var _maxBy2 = _interopRequireDefault(require("lodash/maxBy"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _find2 = _interopRequireDefault(require("lodash/find"));
var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));
var _has2 = _interopRequireDefault(require("lodash/has"));
var _cloneDeep2 = _interopRequireDefault(require("lodash/cloneDeep"));
var _cccisdImpact = require("cccisd-impact");
var _cccisdLoader = _interopRequireDefault(require("cccisd-loader"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _Confetti = _interopRequireDefault(require("../Confetti"));
var _checkmarkCircle = _interopRequireDefault(require("cccisd-icons/checkmark-circle"));
var _allChildrenComplete = _interopRequireDefault(require("../../helpers/allChildrenComplete.js"));
var _FixedSessionWrapper;
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } // Use Pawn List Processor to Build Flow Vars in correct format
// Pass formatted Flow Var data to Data Collection
var mapStateToProps = function mapStateToProps(state, props) {
  return {
    loading: state.appdefs.fixedSession.loading,
    sessions: state.appdefs.fixedSession.sessions,
    activeSession: (0, _fixedSession2.getActiveSession)(state.appdefs.fixedSession),
    currentActivity: (0, _fixedSession2.getCurrentActivity)(state.appdefs.fixedSession)
  };
};
var _default = exports["default"] = (0, _reactRedux.connect)(mapStateToProps, {
  buildState: _fixedSession.buildState,
  changeActiveSession: _fixedSession.changeActiveSession,
  setSessionCalendarMetrics: _fixedSession.setSessionCalendarMetrics,
  changeCurrentActivity: _fixedSession.changeCurrentActivity,
  changeActivityApplicable: _fixedSession.changeActivityApplicable,
  resetState: _fixedSession.resetState,
  markSessionComplete: _fixedSession.markSessionComplete,
  markActivityComplete: _fixedSession.markActivityComplete,
  callPostFlowHook: _fixedSession.callPostFlowHook,
  callPostSessionRoute: _fixedSession.callPostSessionRoute,
  callPostSessionRouteUnload: _fixedSession.callPostSessionRouteUnload
})((_FixedSessionWrapper = /*#__PURE__*/function (_React$Component) {
  _inherits(FixedSessionWrapper, _React$Component);
  function FixedSessionWrapper() {
    var _this;
    _classCallCheck(this, FixedSessionWrapper);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, FixedSessionWrapper, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      _this.determineInitialSession();
      window.addEventListener('beforeunload', _this.callPostSessionRoute);
    });
    _defineProperty(_assertThisInitialized(_this), "componentWillUnmount", function () {
      _this.props.callPostSessionRouteUnload({
        responseSet: _this.props.activeSession.responseSet,
        pawnId: _this.props.pawn.pawn.pawnId,
        pawnHash: _this.props.pawn.pawn.pawnHash
      });
      window.removeEventListener('beforeunload', _this.callPostSessionRoute);
      _this.props.resetState();
    });
    _defineProperty(_assertThisInitialized(_this), "callPostSessionRoute", function () {
      _this.props.callPostSessionRouteUnload({
        responseSet: _this.props.activeSession.responseSet,
        pawnId: _this.props.pawn.pawn.pawnId,
        pawnHash: _this.props.pawn.pawn.pawnHash
      });
    });
    _defineProperty(_assertThisInitialized(_this), "determineInitialSession", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var expandedSessions;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            // determine active session based on playPolicy
            // get a list of sessions and get completed metric
            // expand activities
            expandedSessions = [];
            (0, _filter2["default"])(_this.props.sessionData, function (s) {
              return s.type === _this.props.type;
            }).forEach(function (session) {
              var newActivities = [];
              session.activities.forEach(function (activity) {
                var appdefActivity = (0, _cloneDeep2["default"])((0, _find2["default"])(_this.props.appDefData.fixedSettings.activities, function (a) {
                  return a.handle === activity.handle;
                }));
                appdefActivity.order = activity.order;
                if ('acrossChildren' in activity) {
                  appdefActivity.acrossChildren = activity.acrossChildren;
                  appdefActivity.acrossChildrenSettings = activity.acrossChildrenSettings;
                }
                if ('isDeployment' in activity) {
                  appdefActivity.isDeployment = activity.isDeployment;
                  appdefActivity.deploymentSettings = activity.deploymentSettings;
                }
                if ('withInitialValues' in activity && activity.withInitialValues) {
                  appdefActivity.withInitialValues = activity.withInitialValues;
                  appdefActivity.initialValueSettings = activity.initialValueSettings;
                }
                if ('hidePlayButton' in activity) {
                  appdefActivity.hidePlayButton = activity.hidePlayButton;
                }
                if ('flowVariables' in activity) {
                  if ('flowVarData' in activity) {
                    appdefActivity.flowVarData = activity.flowVarData;
                  }
                  if ('varProcessor' in activity) {
                    appdefActivity.flowVarProcessor = activity.varProcessor;
                    appdefActivity.varProcessor = activity.varProcessor;
                  }
                  if ('varHandle' in activity) {
                    appdefActivity.varHandle = activity.varHandle;
                  }
                  appdefActivity.flowVariables = activity.flowVariables;
                }
                newActivities.push(appdefActivity);
              });
              session.activities = newActivities;
              expandedSessions.push(session);
            });
            _context.next = 4;
            return _this.props.buildState(_this.props.appDefData.fixedSettings.queries[_this.props.type], expandedSessions, {
              pawn: _this.props.pawn,
              role: _this.props.pawnRole
            }, _this.props.playPolicy);
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    _defineProperty(_assertThisInitialized(_this), "onCalendarSubmit", /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(payload) {
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _this.props.setSessionCalendarMetrics(payload, _this.props.pawn, _this.props.playPolicy);
            case 1:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }());
    _defineProperty(_assertThisInitialized(_this), "onFlipperBack", function () {
      // call session unmount route
      _this.props.callPostSessionRoute({
        responseSet: _this.props.activeSession.responseSet,
        pawnId: _this.props.pawn.pawn.pawnId,
        pawnHash: _this.props.pawn.pawn.pawnHash
      });
      // we know that we are not at the end
      _this.props.changeActiveSession(_this.props.sessions[(0, _findIndex2["default"])(_this.props.sessions, function (s) {
        return s.handle === _this.props.activeSession.handle;
      }) - 1], _this.props.appDefData.fixedSettings.queries[_this.props.type], {
        pawn: _this.props.pawn,
        role: _this.props.pawnRole
      }, _this.props.playPolicy);
    });
    _defineProperty(_assertThisInitialized(_this), "onFlipperForward", function () {
      // call session unmount route
      _this.props.callPostSessionRoute({
        responseSet: _this.props.activeSession.responseSet,
        pawnId: _this.props.pawn.pawn.pawnId,
        pawnHash: _this.props.pawn.pawn.pawnHash
      });
      // we know that we are not at the end
      _this.props.changeActiveSession(_this.props.sessions[(0, _findIndex2["default"])(_this.props.sessions, function (s) {
        return s.handle === _this.props.activeSession.handle;
      }) + 1], _this.props.appDefData.fixedSettings.queries[_this.props.type], {
        pawn: _this.props.pawn,
        role: _this.props.pawnRole
      }, _this.props.playPolicy);
    });
    _defineProperty(_assertThisInitialized(_this), "onJumpToSession", function (event) {
      _this.props.callPostSessionRoute({
        responseSet: _this.props.activeSession.responseSet,
        pawnId: _this.props.pawn.pawn.pawnId,
        pawnHash: _this.props.pawn.pawn.pawnHash
      });

      // index to new session is response set -1
      _this.props.changeActiveSession(_this.props.sessions[event.responseSet - 1], _this.props.appDefData.fixedSettings.queries[event.type], {
        pawn: _this.props.pawn,
        role: _this.props.pawnRole
      }, _this.props.playPolicy);
    });
    _defineProperty(_assertThisInitialized(_this), "onActivityFinished", function (flowObj) {
      var handle = flowObj.handle;
      // if this is the last activity and all activities complete

      var finalRemainingActivities = [];

      // this list will include childFlows...need to strip them out if finished
      var remainingActivities = (0, _filter2["default"])((0, _filter2["default"])(_this.props.activeSession.activities, function (act) {
        return act.progress.completed === false;
      }), function (act2) {
        return act2.handle !== handle;
      });
      remainingActivities.forEach(function (ra) {
        if ('acrossChildren' in ra && 'withPicker' in ra.acrossChildrenSettings) {
          if (!(0, _allChildrenComplete["default"])(ra, _this.props.pawn, _this.props.activeSession)) {
            finalRemainingActivities.push(ra);
          }
        } else {
          finalRemainingActivities.push(ra);
        }
      });

      // if the list of remaining activities is not empty, mark complete and goto next
      if (!(0, _isEmpty2["default"])(finalRemainingActivities)) {
        _this.props.markActivityComplete(flowObj.handle);
        _this.nextActivity(flowObj);
      } else {
        _this.props.markSessionComplete(_this.props.activeSession, _this.props.pawn, _this.props.playPolicy);
        _this.props.markActivityComplete(flowObj.handle);
        _this.completeModal.open();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onFlowFinished", function (flowObj) {
      var handle = flowObj.handle,
        flowHandle = flowObj.flowHandle;

      // flow is done, lets call a post flow hook
      _this.props.callPostFlowHook(handle, {
        responseSet: _this.props.activeSession.responseSet,
        pawnId: _this.props.pawn.pawn.pawnId,
        pawnHash: _this.props.pawn.pawn.pawnHash,
        handle: flowHandle,
        child: (0, _has2["default"])(flowObj, 'child') ? flowObj.child : {}
      });
    });
    _defineProperty(_assertThisInitialized(_this), "onActivitySelect", function (tab) {
      _this.props.changeCurrentActivity((0, _find2["default"])(_this.props.activeSession.activities, function (activity) {
        return activity.handle === tab;
      }), _this.props.pawn);
    });
    _defineProperty(_assertThisInitialized(_this), "onActivityApplicableChange", function (activity) {
      _this.props.changeActivityApplicable(activity, !activity.applicable, _this.props.pawn);
    });
    _defineProperty(_assertThisInitialized(_this), "nextActivity", function (flowObj) {
      var currentActivity = {};
      if (_this.props.playPolicy === 'last_incomplete') {
        var maxItem = (0, _maxBy2["default"])((0, _filter2["default"])(_this.props.activeSession.activities, function (a) {
          return a.complete === true;
        }), function (o) {
          return o.responseSet;
        });
        if (maxItem === _this.props.activeSession.activities[_this.props.activeSession.activities.length]) {
          currentActivity = (0, _maxBy2["default"])((0, _filter2["default"])(_this.props.activeSession.activities, function (a) {
            return a.complete === true;
          }), function (o) {
            return o.responseSet;
          });
        } else {
          // set to last completed session + 1
          currentActivity = _this.props.activeSession.activities[(0, _findIndex2["default"])(_this.props.activeSession.activities, maxItem) + 1];
        }
      } else if (_this.props.playPolicy === 'first_incomplete') {
        currentActivity = (0, _find2["default"])(_this.props.activeSession.activities, function (a) {
          return a.progress.completed === false;
        });
      }
      _this.props.changeCurrentActivity(currentActivity, _this.props.pawn);
    });
    _defineProperty(_assertThisInitialized(_this), "closeCompleteModal", function () {
      if (_this.completeModal) {
        _this.completeModal.close();
      }
    });
    return _this;
  }
  _createClass(FixedSessionWrapper, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      if (this.props.loading) {
        return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
          loading: this.props.loading
        }));
      }
      var leftFlipperDisabled = true;
      var rightFlipperDisabled = true;
      if (this.props.activeSession.responseSet !== this.props.sessions[this.props.sessions.length - 1].responseSet) {
        rightFlipperDisabled = false;
      }
      if (this.props.activeSession.responseSet !== this.props.sessions[0].responseSet) {
        leftFlipperDisabled = false;
      }
      var groupName = this.props.appDefData.clientLabelDataField ? this.props.pawn.fields[this.props.appDefData.clientLabelDataField] : this.props.pawn.fields.clientLabel;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdLoader["default"], {
        loading: this.props.loading
      }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
        ref: function ref(input) {
          _this2.completeModal = input;
        },
        title: "Session Complete",
        bodyStyle: {
          overflow: 'hidden'
        },
        onTop: true
      }, /*#__PURE__*/_react["default"].createElement(_Confetti["default"], {
        positionOverride: "absolute"
      }), /*#__PURE__*/_react["default"].createElement("h1", {
        style: {
          textAlign: 'center',
          padding: '200px 0',
          margin: '0'
        }
      }, this.props.activeSession.label, " for ", groupName, " completed!", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          color: '#1ad41b',
          fontSize: '75px'
        }
      }, /*#__PURE__*/_react["default"].createElement(_checkmarkCircle["default"], null))), /*#__PURE__*/_react["default"].createElement("button", {
        type: "button",
        className: "btn btn-success btn-sm",
        style: {
          width: '100%'
        },
        onClick: this.closeCompleteModal.bind(null)
      }, "OK")), /*#__PURE__*/_react["default"].createElement(_cccisdImpact.DataCollection, {
        pawn: this.props.pawn,
        session: this.props.activeSession,
        sessions: this.props.sessions,
        currentActivity: this.props.currentActivity,
        requireCalendarPicker: true,
        showActivityApplicable: this.props.showApplicableToggle,
        onActivityApplicableChange: this.onActivityApplicableChange,
        showActivityComplete: true,
        rightFlipperDisabled: rightFlipperDisabled,
        leftFlipperDisabled: leftFlipperDisabled,
        onCalendarSubmit: this.onCalendarSubmit,
        onFlipperForward: this.onFlipperForward,
        onFlipperBack: this.onFlipperBack,
        onActivityFinished: this.onActivityFinished,
        onFlowFinished: this.onFlowFinished,
        onJumpToSession: this.onJumpToSession,
        onActivitySelect: this.onActivitySelect,
        isHeldMissed: 'isHeldMissed' in this.props.activeSession ? this.props.activeSession.isHeldMissed : true,
        tabWidths: this.props.tabWidths
      })));
    }
  }]);
  return FixedSessionWrapper;
}(_react["default"].Component), _defineProperty(_FixedSessionWrapper, "propTypes", {
  /**
   * Sessions from appdefs, filtered to tab
   */
  sessionData: _propTypes["default"].array.isRequired,
  /**
   * All session.json data
   */
  appDefData: _propTypes["default"].object.isRequired,
  /**
   * A pawn object, probably from graphql
   * {
   *     id: 1,
   *     role: 'someRoleHandle',
   *     ...
   * }
   */
  pawn: _propTypes["default"].object,
  /**
   * role of the pawn
   */
  pawnRole: _propTypes["default"].string,
  /**
   * the type of session to do data entry for
   */
  type: _propTypes["default"].string,
  /**
   * query fields for graphql
   */
  queryFields: _propTypes["default"].array,
  /**
   * what session to load first, will be the same for activities
   * [
   *     last_incomplete,
   *     first_incomplete
   * ]
   */
  playPolicy: _propTypes["default"].string,
  /**
   * the formatted session data
   */
  sessions: _propTypes["default"].array,
  /**
   * the active session, formatted
   */
  activeSession: _propTypes["default"].object,
  /**
   * loading state
   */
  loading: _propTypes["default"].bool,
  /**
   * change active session and run ajax request to get data about that session
   */
  changeActiveSession: _propTypes["default"].func,
  /**
   * set session calendar metrics
   */
  setSessionCalendarMetrics: _propTypes["default"].func,
  /**
   * change the current activity
   */
  changeCurrentActivity: _propTypes["default"].func,
  /**
   * change the applicable state for an activity (flow)
   */
  changeActivityApplicable: _propTypes["default"].func,
  /**
   * show applicable toggle
   */
  showApplicableToggle: _propTypes["default"].bool,
  currentActivity: _propTypes["default"].object,
  resetState: _propTypes["default"].func,
  getFlowVarData: _propTypes["default"].func,
  markSessionComplete: _propTypes["default"].func,
  markActivityComplete: _propTypes["default"].func,
  buildState: _propTypes["default"].func,
  callPostFlowHook: _propTypes["default"].func,
  callPostSessionRoute: _propTypes["default"].func,
  callPostSessionRouteUnload: _propTypes["default"].func,
  tabWidths: _propTypes["default"].object
}), _defineProperty(_FixedSessionWrapper, "defaultProps", {
  playPolicy: 'first_incomplete',
  tabWidths: {
    left: 3,
    right: 9
  }
}), _FixedSessionWrapper));